

global.InterestPage = (function ($) {
	var frequencyTypesMap;
	var calculationTypesMap;

    function init(data) {
		frequencyTypesMap = data.frequencyTypes;
		calculationTypesMap = data.calculationTypes;

		toggleAllCheckboxes();
		initCalculationMethod();
    }

	function toggleAllCheckboxes() {
		var inputGroups = $('.js-input-group');

		inputGroups.each(function (i, ele) {
			var group = $(ele);

			var showGroupBtn = group.find('.js-toggle-group');
			var groupContent = group.find('.js-group-content');

			showGroupBtn.on('click',
				function () {
					groupContent.toggle();
					group.toggleClass('open');
				});

			groupContent.each(function (i, ele) {
				var subGroup = $(ele);

				var showFieldBtn = subGroup.find('.js-toggle-fields');
				var fieldContent = subGroup.find('.js-field-content');

				var toggleCheckboxes = fieldContent.find('.js-toggle-all-checkboxes');

				var toggleCheckboxesLabelCheck = toggleCheckboxes.attr('data-text-check');
				var toggleCheckboxesLabelUncheck = toggleCheckboxes.attr('data-text-uncheck');

				var checkboxes = fieldContent.find('input:checkbox').not('.js-toggle-all-checkboxes');
				
				showFieldBtn.on('click', function () {
					fieldContent.toggle();
					subGroup.toggleClass('open');
				});

				toggleCheckboxes.on('click', function () {
					var isChecked = $(this).is(':checked');
					var labelText = $(this).parent().find('span');

					if (isChecked) {
						checkboxes.prop('checked', true);
						labelText.text(toggleCheckboxesLabelUncheck);
					}
					else {
						checkboxes.prop('checked', false);
						labelText.text(toggleCheckboxesLabelCheck);
					}
				});

				checkboxes.on('click', function () {
					var allCheckboxesAreChecked = checkboxes.not(':checked').length === 0;

					if (allCheckboxesAreChecked) {
						toggleCheckboxes.prop('checked', true);
					} else {
						toggleCheckboxes.prop('checked', false);
					}
				});
			});
		});
	}

	function initCalculationMethod() {
		var $frequencyRadioButtons = $('.js-frequency');
		var $calculationMethodsSection = $('#js-calculation-methods');
		var $calculationMethod = $('.js-calculation-method');
		var $selectedFrequency = $frequencyRadioButtons.filter(':checked');
		var $calculationMethodUltimo = $calculationMethod.filter('[value=' + calculationTypesMap.ultimo + ']');
		var $calculationMethodAverage = $calculationMethod.filter('[value=' + calculationTypesMap.average + ']');

		var setCalculationMethodsShowState = function ($frequency) {
			var selection = $frequency.val();

			var sectionShowBeShown = selection !== frequencyTypesMap.day;
			var ultimoShouldBeShown = selection === frequencyTypesMap.month;
			
			$calculationMethodsSection.toggle(sectionShowBeShown);
			$calculationMethodUltimo.closest('label').toggle(ultimoShouldBeShown);

			if (ultimoShouldBeShown === false) {
				$calculationMethodUltimo.prop('checked', false);
			}

			if (sectionShowBeShown === false) {
				$calculationMethod.each(function () {
					if ($(this).is($calculationMethodAverage) === false) {
						$(this).prop('checked', false);	
					}
				});
			}
		};

		setCalculationMethodsShowState($selectedFrequency);

		$frequencyRadioButtons.on('change', function () {
			setCalculationMethodsShowState($(this));
		});
	}

	return {
		init: init
	};
})(jQuery);
